export const formatFileSize = size => {
  const sufixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(size) / Math.log(1024))
  return (
    (!size && '0 B') || `${(size / Math.pow(1024, i)).toFixed(0)} ${sufixes[i]}`
  )
}
